import { render, staticRenderFns } from "./performance-block.vue?vue&type=template&id=0a3d2538&scoped=true"
import script from "./performance-block.vue?vue&type=script&lang=ts"
export * from "./performance-block.vue?vue&type=script&lang=ts"
import style0 from "./performance-block.vue?vue&type=style&index=0&id=0a3d2538&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d2538",
  null
  
)

export default component.exports